<script setup lang="ts">
  import { computed, watch } from "vue";
  import { storeToRefs } from "pinia";
  import { useAnnouncementsStore } from "@stores/announcements";
  import { useCurrentUserStore } from "@stores/currentUser";
  import AnnouncementCard from "@/components/Announcements/AnnouncementCard.vue";

  const STACK_OFFSET_PX = 4;

  const announcementsStore = useAnnouncementsStore();
  const { current, currentPosition, unreadCount, unreadTotal } = storeToRefs(announcementsStore);
  const { isLoggedIn } = storeToRefs(useCurrentUserStore());

  const stackLayers = computed(() => [2, 1].filter((layer) => layer < unreadCount.value));

  watch(
    isLoggedIn,
    (loggedIn) => {
      if (loggedIn) announcementsStore.fetchUnread();
    },
    { immediate: true },
  );
</script>

<template>
  <div
    v-if="isLoggedIn && current"
    class="px-2 pb-2">
    <div
      class="relative"
      :style="{
        marginRight: `${stackLayers.length * STACK_OFFSET_PX}px`,
        marginBottom: `${stackLayers.length * STACK_OFFSET_PX}px`,
      }">
      <div
        v-for="layer in stackLayers"
        :key="layer"
        class="absolute inset-0 rounded-lg border border-episto-teal/25 bg-white shadow-sm transition-transform duration-200"
        :style="{ transform: `translate(${layer * STACK_OFFSET_PX}px, ${layer * STACK_OFFSET_PX}px)` }" />
      <Transition
        enter-active-class="transition delay-100 duration-200 ease-out"
        enter-from-class="translate-x-1 translate-y-1 opacity-0"
        leave-active-class="absolute inset-x-0 top-0 z-10 transition duration-150 ease-in"
        leave-to-class="-translate-x-3 opacity-0">
        <div :key="current.id">
          <AnnouncementCard
            :announcement="current"
            :position="currentPosition"
            :total="unreadTotal"
            @close="announcementsStore.dismissCurrent('closed')"
            @open="announcementsStore.dismissCurrent('link_clicked')" />
        </div>
      </Transition>
    </div>
  </div>
</template>
